import {VictorModelFilter} from '@volkswagen-onehub/car-technical-details-bff';

export function getKeyByDiscriminators(filters: {
  [key: string]: VictorModelFilter[];
}): string {
  return Object.keys(filters)
    .map((k) => k + filters[k].map((f) => f.text).join('-'))
    .join(':');
}
